import {
  AfterViewChecked, ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges
} from '@angular/core';
import {AppSettingsService} from '../../services/app-settings.service';

@Component({
  selector: 'app-details-div',
  template: `
    <div class="list">
      <div class="item" id="id">
        <div class="avatar"><i class="icon {{icon}}"></i></div>
        <div class="text"><h2 style="text-align: right">{{header}}</h2>
          <p style="text-align: right"></p>
        </div>
        <div *ngFor="let item of dividedArray" class="{{maxRowCount ? 'detail' : 'detail fill-height-or-more'}}">
          <div *ngFor="let innerItem of item | keyvalue" [ngClass]="maxRowCount ? 'col col-12'
                : getItemCount(item) % rawCount === 0 ? 'col col-' + 12 / rawCount
                 : 'col col-' + 12 / getItemCount(item)">
            <h2>{{Translator.translateEnglish(innerItem.key, translation)}}</h2>
            <span>{{Translator.translateEnglish(innerItem.value, translation)}}</span>
          </div>
        </div>
        <app-custom-button [LabelText]="Translator.translateEnglish(mainLabel, translation)"
                           [backButtonLabel]="Translator.translateEnglish(backLabel, translation)"
                           [Show]="true"
                           [disabled]="false"
                           [BackButton]="backLabel !== ''"
                           [HideMainButton]="mainLabel === '' || !mainLabel"
                           (OnClick)="mainSubmit()"
                           (OnGoBack)="secondarySubmit()"
                           [backUrl]="backUrl">
        </app-custom-button>
      </div>
    </div>
  `,
  styleUrls: [
    '../../assets/Content/src/css/lib.vendor.css',
    '../../assets/Content/src/css/lib.picker.css',
    '../../assets/Content/src/css/ini.bime.css',
    '../../assets/vendor/font-awesome-4.7/css/font-awesome.min.css',
    '../../assets/css/light.theme.css'
  ],
  styles: [`
    .list .item {
      margin-bottom: 15px;
      padding: 15px 75px 15px 15px;
      overflow: hidden;
      position: relative;
      border-radius: 5px;
      background-color: white;
      box-shadow: 0 1px 2px rgba(0, 0, 0, .07);
      animation: flipy 1s both;
    }

    .item:last-child {
      margin-bottom: 0;
    }

    .list .item .avatar {
      width: 60px;
      height: 40px;
      padding: 0 7.5px 0 10px;
      position: absolute;
      top: 15px;
      right: 0;
      line-height: 40px;
      text-align: center;
      color: #919fb1;
      border-radius: 20px 0 0 20px;
      background-color: #f2f1ef;
    }

    .list .item .avatar .icon {
      font-size: 215%;
    }

    .list .item .text {
      margin-bottom: 15px;
    }

    .list .item .detail {
      margin-bottom: 10px;
      text-align: center;
      position: relative;
    }

    .fill-height-or-more {
      display: flex;
    }

    .fill-height-or-more > div {
      display: flex;
      flex-direction: column;
    }

    .list .item .detail:last-child {
      margin-bottom: 0;
    }

    .list .item .detail .col {
      padding: 5px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: normal;
      position: relative;
      border: 1px solid #f2f1ef;
      border-radius: 5px;
    }

    .list .item .detail-info {
      font-size: 95%;
    }

    .list .item .detail-info .txt-justify {
      white-space: normal;
      line-height: normal;
    }

    .list .item .detail-info .test-list {
      margin-top: 10px;
      padding-right: 10px;
    }

    .list .item .btn-holder .btn {
      border-radius: 5px;
    }

    .list .item .btn-holder .btn-accept {
      background-color: #12b886;
    }

    .list .item .btn-holder .btn-test {
      background-color: #228be6;
    }
  `]
})
export class DetailsDivComponent implements OnInit, OnChanges {
  @Input() id: number;
  @Input() header: string;
  @Input() array: any;
  @Input() rawCount: number;
  @Output() takeAction = new EventEmitter<number>();
  @Output() secondaryClicked = new EventEmitter<number>();
  @Input() icon: string;
  @Input() dividedArray = [];
  @Input() mainLabel: string;
  @Input() backLabel: string;
  @Input() showControls: boolean;
  @Input() backUrl: string;
  @Input() maxRowCount: boolean;
  @Input() translation: any = {};

  constructor(private cdRef: ChangeDetectorRef,
              public Translator: AppSettingsService) {
  }

  ngOnInit() {
    if (!this.icon) {
      this.icon = 'ico-person-outline';
    }
    if (this.maxRowCount) {
      this.rawCount = this.getItemCount(this.array);
    }
    while (Object.keys(this.array).length >= this.rawCount) {
      const j = this.dividedArray.length;
      this.dividedArray[j] = {};
      console.log(Object.keys(this.array));
      for (let i = 0; i < 3; i++) {
        this.dividedArray[j][Object.keys(this.array)[i]] = this.array[Object.keys(this.array)[i]];
      }
      this.delete(3, this.array);
    }
    if (Object.keys(this.array).length) {
      const j = this.dividedArray.length;
      this.dividedArray[j] = {};
      // tslint:disable-next-line:prefer-for-of
      for (let i = 0; i < Object.keys(this.array).length; i++) {
        this.dividedArray[j][Object.keys(this.array)[i]] = this.array[Object.keys(this.array)[i]];
      }
      this.array = {};
    }
    console.log(this.dividedArray);
  }

  getItemCount(keyValueArray) {
    return Object.keys(keyValueArray).length;
  }

  delete(count, array) {
    for (let i = 0; i < count; i++) {
      delete array[Object.keys(array)[0]];
    }
  }

  // action($event: MouseEvent) {
  //   this.takeAction.emit(this.id);
  // }
  //
  // button() {
  //   this.setButton.emit(this.id);
  // }

  mainSubmit() {
    this.takeAction.emit(this.id);
  }

  secondarySubmit() {
    this.secondaryClicked.emit();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.mainLabel.firstChange) {
      this.cdRef.detectChanges();
      console.log(this.mainLabel);
      // if (!changes.mainLabel.firstChange) {
      console.log(this.mainLabel);
      console.log(this.mainLabel === '');
      // this.mainLabel = changes.mainLabel.currentValue;
      // }
    }
  }
}
